<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row>
          <el-col class="table-header">
            <div class="table-heade-left">
              <el-form :inline="true" :model="searchCondition">
                <el-form-item label="">
                  <el-select v-model="searchCondition.status" @change="selectClick" size="small" class="select-wrapper">
                    <el-option label="全部审核状态" value=""></el-option>
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="searchCondition.name" placeholder="输入公司" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item>
                  <el-input v-model="searchCondition.created_name" placeholder="输入创建人" clearable></el-input>
                </el-form-item> -->
                <el-form-item>
                  <el-button type="primary" @click="searchButton">查询</el-button>
              </el-form-item>
              </el-form>
            </div>
            <div class="table-heade-right">
              <el-button type="primary" @click="createCompany" v-if="userPermissions.indexOf('company_creat') != -1">创建公司</el-button>
            </div>
          </el-col>
        </el-row>
        <TreeTable :data="list" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" ref="treeTable" highlight-current-row >
          <!-- <el-table-column
          slot="first-column"
          width="80"
          align="center"
          label="Drag">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="拖动排序" placement="top-start">
                <span class="drag-handle" :data-id="scope.row.id" :data-parent_id="scope.row.parent_id" :data-depth="scope.row.depth"><i class="el-icon-rank"></i></span>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <el-table-column
          width="80"
          align="center"
          label="状态">
            <template slot-scope="scope">
             <div :class="scope.row.alias_status == '待审核' ? 'add-color' : ''">{{ scope.row.alias_status }}</div>
            </template>
          </el-table-column>
          <el-table-column
          width="250"
          align="center"
          label="操作">
            <template slot-scope="scope">
              <el-button size="mini" icon="iconfont" @click="addButton(scope.row.id)">添加子公司</el-button>
              <el-button size="mini" type="primary" @click="editButton(scope.row.id, scope.row.name)" v-if="userPermissions.indexOf('company_edit') != -1">编辑</el-button>
              <el-popover
                v-if="userPermissions.indexOf('company_delete') != -1"
                :ref="'el-popover-'+scope.$index"
                placement="top"
                width="150">
                <p>确定要删除记录吗？</p>
                <div style="text-align: right; margin: 0;">
                  <el-button type="text" size="mini" @click="$refs['el-popover-'+scope.$index].doClose()">取消</el-button>
                  <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                </div>
                <el-button slot="reference" type="danger" size="mini">删除</el-button>
              </el-popover>
              <el-button size="mini" type="text" @click="toExamine(scope.row.id)" v-if="userPermissions.indexOf('company_audit') != -1&&scope.row.status==0">审核</el-button>
            </template>
          </el-table-column>
        </TreeTable>
      </div>
    </PageHeaderLayout>
    <!-- 审核模态框 -->
    <ModalDialog :dialogData="examineDialogData" @dialogConfirm="examineHandleConfirm" @dialogClose="examineDialogClose">
      <template slot="content">
        <el-form :model="examineRuleForm" ref="examineRuleForm" class="demo-ruleForm" :label-position="'right'" >
          <el-form-item>
            <el-radio-group v-model="examineRuleForm.status" @change="selectRadio">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">拒绝</el-radio>
              <!-- <el-radio label="3">禁用</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="examineRuleForm.status == 2">
            <el-input type="textarea" :rows="4" v-model="examineRuleForm.review_remark" placeholder="请输入拒绝原因"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import TreeTable from '@/components/TreeTable'
import ModalDialog from '@/components/ModalDialog'
import { mapGetters } from "vuex";

export default {
  components: {
    PageHeaderLayout,
    TreeTable,
    ModalDialog,
  },
  watch: {
    "$route.matched": function(n) {
      if (n.length === 2) {
        this.init();
      }
    },
    "examineRuleForm.status": function(val) {
      if(val) {
        this.examineDialogData.loading = false
      }else {
        this.examineDialogData.loading = true
      }
    },
  },
  data() {
    return {
      examineDialogData: {//审核模态框
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
      examineRuleForm: {//审核表单数据
        id: '',
        status: '',
        review_remark: ''
      },
      options: [{//筛选状态
        value: '1',
        label: '通过'
      }, {
        value: '2',
        label: '拒绝'
      }, {
        value: '0',
        label: '审核中'
      }, {
        value: '3',
        label: '禁用'
      }],
      loadingStaus: true,
      searchCondition: {
        status: ''
      },
      columns: [
        {
          title: '公司名称',
          operation:true, // 作为展开操作列
          value: 'name',
          header_align: 'left',
          align: 'left',
          width: 260
        },
        {
          title: '公司账号',
          header_align: 'center',
          align: 'center',
          value: 'account'
        },
        {
          title: '开户行',
          header_align: 'center',
          align: 'center',
          value: 'bank',
          width: 300
        },
        {
          title: '企业电话',
          header_align: 'center',
          align: 'center',
          value: 'company_phone'
        },
        {
          title: '创建人',
          header_align: 'center',
          align: 'center',
          value: 'created_name'
        },
        {
          title: '驳回原因',
          header_align: 'center',
          align: 'center',
          value: 'review_remark'
        },
        {
          title: '创建时间',
          header_align: 'center',
          width: 200,
          align: 'center',
          value: 'created_at'
        },
      ],
      list:[],// 表格列表数据
      pagingData:{// 分页信息
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      offset:0,// 分页的offset,序号列使用
    }
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    //审核
    async companyAudit() {
      let args = {
        status: this.examineRuleForm.status,
        review_remark: this.examineRuleForm.review_remark
      }
      let result = await this.$api.companyAudit(this.examineRuleForm.id, args)
      if(result) {
        // 调用组件的数据验证方法
        this.examineRuleForm = {}
        this.examineDialogData.visible = false
        this.init()
      }
    },
    // 处理审核模态框，确定事件
    examineHandleConfirm() {
     this.companyAudit()
    },
    //处理审核模态框，关闭事件
    examineDialogClose() {
      this.examineRuleForm = {}
      this.examineDialogData.visible = false
    },
    //审核状态单选操作
    selectRadio() {
      if(this.examineRuleForm.status == 2) {
        this.examineRuleForm.review_remark = ''
      }
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    //点击tab切换
    async handleClick(tab) {
      if (tab.name == 'all') { // 全部批次
        this.searchCondition.status = tab.name
        this.init('all')
      } else if(tab.name == 'cancel') {  // 作废批次
        this.searchCondition.status = tab.name
        this.init('cancel')
      }
      this.resetPage()
    },
    //按状态塞选数据
    selectClick(event) {
      if(event == '1'){
        this.searchCondition.status = event
        this.init('1')
      }
      if(event == '0'){
        this.searchCondition.status = event
        this.init('0')
      }
      if(event == '2'){
        this.searchCondition.status = event
        this.init('2')
      }
      if(event == '3'){
        this.searchCondition.status = event
        this.init('3')
      }
    },
    //创建公司
    createCompany() {
      this.$router.push({
        path: this.$route.path + "/create",
        query:{ category: 'ordinary'}
      })
    },
    //审核
    toExamine(id) {
      this.examineDialogData.title = `审核${id}`
      this.examineDialogData.visible = true
      this.examineRuleForm.id = id
    },
    //查询
    searchButton() {
      this.init()
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.status) {
        condition.status = this.searchCondition.status
      }
      if(this.searchCondition.created_name) {
        condition.created_name = this.searchCondition.created_name
      }
      return condition
    },
    // 添加商户
    addButton(id) {
      this.$router.push({
        path: this.$route.path + "/" + id + "/create",
        query: { category: 'ordinary', id: id, son: 'son'}
      })
    },
    // 编辑商户
    editButton(id, name) {
      this.$router.push({
        path: this.$route.path + "/" + id + "/edit",
        query: { category: 'ordinary', id: id, name: name}
      })
    },
    // 删除商户
    async deleteButton(id) {
      await this.$api.deleteCompany(id)
      this.init()
    },
    // 初始化公司列表
    async init(type) {
      this.loadingStaus = true;
      let pagingInfo = this.$refs['treeTable'].getPagingInfo(type)
      let searchCondition = this.handleSearchCondition()
     
      Object.assign(searchCondition,pagingInfo)
      
       let { data, pages } = await this.$api.getCompanyList(searchCondition)
        this.$nextTick(() => {
          this.list = data
        })
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus=false
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .add-color
    color: #f56c6c
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
    display: flex
    justify-content: space-between
  .table-heade-left
    display: flex
  .create-btn
    height: 36px
  .drag-handle
    font-size 24px
    cursor pointer
  .select-wrapper
    width: 150px
</style>
